import React from 'react';
import PropTypes from 'prop-types';
import { NavLink, useLocation } from 'react-router-dom';

const AppNavLink = React.forwardRef(
  ({ activeClassName, className, ...rest }, ref) => {
    const location = useLocation();
    const isActiveMenu = rest?.exact ? location.pathname === rest?.to : !rest.parent_url ? location.pathname.startsWith(rest?.url) :  location.pathname.startsWith(rest?.parent_url);
 
    return (
      <NavLink
        ref={ref}
        {...rest}
        className={() => {
          return isActiveMenu ? `${activeClassName} ${className}` : className
        }
        }
      />
    );
  },
);

export default AppNavLink;
AppNavLink.propTypes = {
  activeClassName: PropTypes.any,
  className: PropTypes.any,
};
